export function getBasicAuthToken() {
  return "MDEzNTYwZmMtMTRlZC00NjVlLWFkYWMtNWRkMmIxZGFjZWUxOmNlNjgyMDZmLTkyOTQtNGZkZC04MmNiLTNiODM4NDk1MjJhNA==";
}
export function getRandomUUID() {
  return sessionStorage.getItem("sessionToken");
}
